const SITE_ORIGIN = "https://www.olzoom.com";

export const GUIDE_POSTS = [
  {
    slug: "naver-shopping-rank-up",
    title: "네이버 매출 상승의 기본, 네이버 매출 상승하는 방법",
    description:
      "네이버 쇼핑 순위 상승은 키워드를 검색했을 때 상품(플레이스)이 위에 뜨는 것을 말합니다.유입플과 리워드의 차이, 그리고 실제 사용자 방문이 필요한 이유를 정리했습니다.",
    keywords:
      "네이버 쇼핑 순위 상승, 네이버 쇼핑 순위 올리는 방법, 스마트스토어 순위, 리워드, 유입플, 네이버 쇼핑 매출 올리는 방법",
    publishedAt: "2026-09-16",
    sections: [
      {
        heading: "검색했을 때 상품(플레이스)이 위에 떠야 합니다",
        paragraphs: [
          "구매자들이 키워드를 검색했을 때 상품(플레이스)이 위에 보이는 것이 매출 상승의 기본 조건입니다.",
          "네이버 스마트스토어에서 키워드를 검색해 상품을 상단에 노출하려면, 유입플과 리워드를 씁니다.",
          "둘 다 상품 페이지로 들어오는 방문(트래픽)을 만들지만, 만드는 방식이 다릅니다.",
        ],
      },
      {
        heading: "유입플과 리워드",
        paragraphs: [
          "유입플은 프로그램으로 방문자, 즉 트래픽을 강제로 올리는 방식입니다. 사람이 검색해서 들어온 방문이 아니라, 방문 횟수 자체를 만들어 넣는 쪽에 가깝습니다.",
          "리워드는 실제 사용자가 리워드 앱(캐시플랜, 토스 등)에서 해당 상품 페이지를 방문하면 포인트를 받는 방식입니다. 즉 방문의 주체가 프로그램이 아니라 사용자입니다.",
        ],
      },
      {
        heading: "유입플만으로는 순위가 오르지 않습니다",
        paragraphs: [
          "유입플은 최근 네이버 보안 강화로 위험성이 커지고 있습니다. 프로그램을 이용해 방문을 넣는 방식은, 순위 상승에 도움이 되기보다 부담이 될 수 있습니다.",
          "유입플을 많이 넣는다고 순위가 올라가는 것도 아닙니다.",
        ],
      },
      {
        heading: "리워드를 써야하는 이유",
        paragraphs: [
          "검색 결과 상위에 뜨려면 리워드를 적극적으로 써야합니다.",
          "실제 사용자가 그 키워드와 연결된 상품 페이지를 찾아 들어오는 방문이 반복되어야, 상품이 위에 보일 자리가 생깁니다.",
          "한 번에 숫자만 키우기보다, 판매가 감당할 수 있는 범위에서 사용자 방문이 이어지는 편이 자연스럽습니다.",
        ],
      },
      {
        heading: "올려줌은 리워드로 진행합니다",
        paragraphs: [
          "올려줌은 자사 앱과 대기업 앱을 통해, 실제 사용자가 참여하는 고품질 리워드를 기반으로 광고를 진행합니다.",
          "프로그램으로 트래픽을 넣는 유입플이 아니라, 사용자가 상품 페이지를 방문하는 방식입니다.",
          "목표 키워드, 유입 키워드, 하루 유입 수, 진행 기간을 직접 정해 간편히 직접 등록할 수 있습니다.",
        ],
      },
    ],
  },
];

export const getGuidePost = (slug) =>
  GUIDE_POSTS.find((post) => post.slug === slug) || null;

export const getGuidePostUrl = (slug) => `${SITE_ORIGIN}/guide/${slug}`;

export const GUIDE_INDEX_URL = `${SITE_ORIGIN}/guide`;
